export const categories = [
  {
    slug: 'kexue-renzhi',
    name: '手淫的科学认知',
    description: '从生理学与医学角度理解手淫行为',
    icon: 'ri-microscope-line',
    color: 'primary',
  },
  {
    slug: 'pinlv-jiankang',
    name: '手淫频率与健康',
    description: '探讨频率标准与身体健康的关系',
    icon: 'ri-heart-pulse-line',
    color: 'accent',
  },
  {
    slug: 'xinli-yingxiang',
    name: '手淫心理影响',
    description: '分析手淫对心理健康的多维影响',
    icon: 'ri-psychotherapy-line',
    color: 'primary',
  },
  {
    slug: 'changjian-wuqu',
    name: '手淫常见误区',
    description: '破除迷信与流传广泛的错误观念',
    icon: 'ri-error-warning-line',
    color: 'accent',
  },
  {
    slug: 'xing-jiaoyu',
    name: '成年人性健康教育',
    description: '面向成年人的系统性健康知识科普',
    icon: 'ri-book-open-line',
    color: 'secondary',
  },
  {
    slug: 'xingwei-guanli',
    name: '自慰行为管理',
    description: '建立健康的行为模式与自我管理策略',
    icon: 'ri-mental-health-line',
    color: 'secondary',
  },
];

export interface Article {
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  content: string;
  author: string;
  date: string;
  readTime: string;
  imageUrl: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: 'shouyin-de-shenglixue-jichu',
    title: '手淫的生理学基础：身体如何反应',
    category: 'kexue-renzhi',
    excerpt: '从神经科学和内分泌学角度，深入了解手淫过程中身体发生的生理变化，包括神经递质释放、激素波动以及大脑奖励回路的激活机制。',
    content: '<h2>引言</h2><p>手淫是人类普遍的生理行为，几乎所有文化背景下的成年人都曾有过此类体验。理解其背后的生理学机制，有助于我们以科学的态度看待这一自然行为。</p><h2>神经系统的参与</h2><p>在手淫过程中，中枢神经系统和周围神经系统协同工作。触觉刺激通过感觉神经纤维传递至脊髓，再上传至大脑的感觉皮层。大脑中的<strong>奖励回路</strong>——尤其是伏隔核和腹侧被盖区——在此过程中被显著激活。</p><h2>关键神经递质的变化</h2><p><strong>多巴胺</strong>是其中最核心的神经递质。在性唤起阶段，多巴胺水平逐步上升，引发愉悦感和期待感。达到高潮时，多巴胺会达到峰值，随后出现短暂回落。</p><p>此外，<strong>催产素</strong>和<strong>催乳素</strong>在高潮后释放，前者促进放松和满足感，后者则与性满足后的不应期有关。</p><h2>内分泌系统的响应</h2><p>手淫对激素水平的影响相对温和。研究表明，适度的手淫行为不会导致睾酮水平的显著长期变化，但可能引起短期的波动。对于女性，手淫同样会触发雌激素和孕激素的自然节律变化。</p><h2>心血管系统的反应</h2><p>性唤起和性高潮期间，心率会适度增加，血压也会有所上升。这种变化与轻度至中度运动的生理反应相似，对于心血管健康的人来说是完全正常的。</p><h2>结论</h2><p>手淫是一个涉及多个生理系统协同工作的复杂过程。科学地认识这些机制，能帮助我们消除不必要的恐惧和误解，以更加健康平和的心态面对这一自然行为。</p>',
    author: '李明',
    date: '2026-03-15',
    readTime: '8 分钟',
    imageUrl: 'https://bodymindapp.github.io/api/search-image?query=Scientific%20illustration%20of%20human%20nervous%20system%20with%20warm%20soft%20lighting%20medical%20diagram%20style%20minimalist%20aesthetic%20clean%20background&width=800&height=600&seq=article-shenglixue&orientation=landscape',
    tags: ['生理学', '神经系统', '内分泌'],
  },
  {
    slug: 'shouyin-de-yixue-yanjiu-zongshu',
    title: '手淫的医学研究综述：全球学术界怎么说',
    category: 'kexue-renzhi',
    excerpt: '综合梳理近五十年来国际医学界关于手淫行为的主要研究成果，涵盖流行病学、泌尿学、心理学和公共卫生等多个领域。',
    content: '<h2>研究历史回顾</h2><p>自20世纪中期以来，学术界对手淫的研究经历了从禁忌到科学化的转变。以金赛报告（Kinsey Reports）为里程碑，手淫逐渐成为性医学研究的正当课题。</p><h2>流行病学数据</h2><p>多个国家的大规模调查显示，<strong>超过90%的男性和约70-80%的女性</strong>报告曾有过手淫行为。这些数据表明手淫是人类性行为的普遍组成部分，而非异常或病态行为。</p><h2>泌尿学视角</h2><p>多项研究探讨了手淫与前列腺健康的关系。一些研究提示，<strong>适度的射精频率可能与较低的前列腺癌风险相关</strong>，但这一关联的因果机制仍需进一步研究确认。</p><h2>公共卫生意义</h2><p>世界卫生组织（WHO）及多国公共卫生机构将手淫视为安全的性行为方式，并在性教育中予以科学的介绍。手淫不涉及性传播疾病风险，也不导致意外怀孕，是一种安全的性释放途径。</p><h2>跨文化比较</h2><p>不同文化背景下对手淫的态度差异巨大，但生理行为本身具有跨文化的普遍性。研究表明，<strong>社会文化因素</strong>对手淫后的心理感受（如内疚感）有显著影响，而非行为本身所致。</p><h2>未来研究方向</h2><p>当前学术界的关注点正从"手淫是否有害"转向更为细致的问题，如个体差异、频率与健康的剂量-效应关系，以及数字化时代色情内容消费对手淫行为模式的影响。</p>',
    author: '王芳',
    date: '2026-04-20',
    readTime: '10 分钟',
    imageUrl: 'https://bodymindapp.github.io/api/search-image?query=Academic%20medical%20research%20library%20with%20scientific%20journals%20and%20warm%20lighting%20scholarly%20atmosphere%20minimalist%20clean%20design&width=800&height=600&seq=article-yixueyanjiu&orientation=landscape',
    tags: ['医学研究', '流行病学', '公共卫生'],
  },
  {
    slug: 'butong-nianling-duan-de-shouyin',
    title: '不同年龄段的手淫行为特征',
    category: 'kexue-renzhi',
    excerpt: '探讨从青春期到中老年各年龄段手淫行为的特点、频率变化及相应的健康关注要点。',
    content: '<h2>青春期：探索与发现</h2><p>青春期是手淫行为最常开始的时期。伴随性激素水平的急剧变化和性意识的觉醒，青少年通过手淫探索自身身体，这是<strong>正常的性心理发展阶段</strong>。</p><p>家长和教育者应以开放、科学的态度引导青少年建立健康的性观念，避免过度恐吓或羞辱，这反而可能导致性心理健康问题。</p><h2>青年时期：频率高峰期</h2><p>20至35岁通常为手淫频率最高的阶段。此阶段的频率差异极大，从每周数次到每天不等，均属正常范围。关键在于<strong>不影响日常生活质量和社交功能</strong>。</p><h2>中年时期：稳定与调适</h2><p>进入中年后，手淫频率可能自然下降，但手淫仍是许多中年人重要的性活动方式。对于长期伴侣关系中的个体，手淫可以是一种<strong>健康的自我关怀行为</strong>，不需要替代伴侣间的性生活。</p><h2>老年时期：延续与健康</h2><p>老年人的手淫行为常被忽视。研究表明，许多健康老年人持续拥有性需求，手淫是维持性功能和生活质量的重要方式。盆腔血流增加和会阴部肌肉活动甚至有助于<strong>延缓某些年龄相关的泌尿生殖系统退行性变化</strong>。</p><h2>总结</h2><p>手淫行为贯穿人的一生，各阶段有其特点和意义。科学的态度是：不夸大危害，也不回避讨论，而是基于循证医学信息，帮助每个年龄段的个体建立适合自己的健康行为模式。</p>',
    author: '陈静',
    date: '2026-05-10',
    readTime: '9 分钟',
    imageUrl: 'https://bodymindapp.github.io/api/search-image?query=Life%20stages%20timeline%20illustration%20showing%20human%20development%20from%20youth%20to%20elder%20warm%20colors%20soft%20lighting%20clean%20design&width=800&height=600&seq=article-nianling&orientation=landscape',
    tags: ['年龄段', '发育', '终身健康'],
  },
  {
    slug: 'shouyin-pinlv-de-kexue-biaozhun',
    title: '手淫频率的科学标准：多少才算"正常"',
    category: 'pinlv-jiankang',
    excerpt: '医学界并不存在一个"标准"手淫频率数值。本文从个体差异、生理反馈和文化背景等维度，帮助读者建立科学合理的自我评估框架。',
    content: '<h2>"正常频率"是一个伪命题</h2><p>首先需要明确：<strong>不存在一个适用于所有人的"正常手淫频率"</strong>。个体之间的差异是巨大的，从每月数次到每天数次，都可以是健康的。</p><h2>医学界的判断标准</h2><p>临床医学关注的不是频率本身，而是行为是否满足以下<strong>健康标准</strong>：</p><ul><li>不导致身体疼痛或损伤</li><li>不影响正常的社交、工作和日常生活</li><li>不伴随强烈的心理痛苦或失控感</li><li>不取代伴侣间的正常性生活（对于有伴侣的人）</li></ul><h2>影响频率的因素</h2><p>手淫频率受多种因素影响：<strong>年龄</strong>（年轻人通常频率更高）、<strong>激素水平</strong>、<strong>心理状态</strong>（压力大时可能增加或减少）、<strong>关系状态</strong>、<strong>文化背景</strong>和<strong>个人体质</strong>。</p><h2>何时需要关注</h2><p>当手淫行为出现以下特征时，建议寻求专业帮助：</p><ul><li>无法控制的强迫性冲动</li><li>导致生殖器区域的反复损伤</li><li>严重影响工作或社交生活</li><li>伴有强烈的羞耻、焦虑或抑郁情绪</li></ul><h2>建立自我评估框架</h2><p>与其纠结于频率数字，不如问自己几个问题：这个行为是否让我感觉良好？是否影响了我的生活目标？我是否能够自主控制？如果答案都是肯定的，那么你的频率对你来说就是合适的。</p>',
    author: '张伟',
    date: '2026-02-28',
    readTime: '7 分钟',
    imageUrl: 'https://bodymindapp.github.io/api/search-image?query=Balanced%20scale%20illustration%20with%20health%20symbols%20warm%20neutral%20tones%20clean%20minimalist%20design%20professional&width=800&height=600&seq=article-pinlv&orientation=landscape',
    tags: ['频率标准', '自我评估', '个体差异'],
  },
  {
    slug: 'guodu-shouyin-de-jiemi',
    title: '"过度手淫"的真相：医学界定与自我判断',
    category: 'pinlv-jiankang',
    excerpt: '"过度手淫"是互联网上常见的焦虑来源。本文从循证医学角度，厘清这一概念的医学定义、实际危害和自我判断方法。',
    content: '<h2>概念辨析</h2><p>"过度手淫"这一说法在民间广泛流传，但在现代医学诊断体系中<strong>并不存在这一正式诊断名称</strong>。与之最接近的临床概念是"强迫性性行为障碍"（Compulsive Sexual Behavior Disorder, CSBD），后者已被世界卫生组织纳入ICD-11诊断体系。</p><h2>强迫性性行为障碍的特征</h2><p>CSBD的核心特征不是行为的频率，而是<strong>失控感</strong>：</p><ul><li>反复出现无法控制的强烈性冲动</li><li>将大量时间投入到性行为中，忽视其他重要生活领域</li><li>即使产生明显的负面后果（如关系破裂、经济损失、健康问题），仍无法减少行为</li><li>试图减少或停止时感到明显的痛苦</li></ul><h2>常见但非病理性的情况</h2><p>许多人自认为"过度"，实际上只是频率偏高。以下情况<strong>通常不属于病态</strong>：</p><ul><li>青春期或青年期的自然高频</li><li>压力时期的暂时性增加</li><li>单身时期的正常需求释放</li><li>频率高于平均水平但不影响生活功能</li></ul><h2>身体的实际反馈机制</h2><p>身体有自我保护机制。当频率过高时，可能出现<strong>暂时性不应期延长</strong>、局部轻微不适等信号。这些都是身体的正常反馈，通常不会导致永久性损害。</p><h2>如何科学自我评估</h2><p>可以做一个简单的自我检查：你的手淫行为是"你想要"还是"你不得不"？如果答案是前者且不损害生活其他方面，那么大概率无需担忧；如果答案是后者且伴随显著的痛苦和功能障碍，建议寻求专业心理咨询。</p>',
    author: '张伟',
    date: '2026-06-05',
    readTime: '8 分钟',
    imageUrl: 'https://bodymindapp.github.io/api/search-image?query=Medical%20consultation%20scene%20with%20doctor%20and%20patient%20warm%20lighting%20professional%20setting%20modern%20minimalist%20design&width=800&height=600&seq=article-guodu&orientation=landscape',
    tags: ['过度手淫', '强迫性行为', '自我评估'],
  },
  {
    slug: 'shouyin-yu-shengzhi-jiankang',
    title: '手淫与生殖健康：你需要知道的科学事实',
    category: 'pinlv-jiankang',
    excerpt: '探讨手淫对男性和女性生殖系统健康的实际影响，基于循证医学证据澄清常见的担忧和误解。',
    content: '<h2>男性生殖健康</h2><p>关于手淫与前列腺健康，一些流行病学研究提示了有趣的关联。一项具有影响力的研究（哈佛大学卫生专业人员随访研究）发现，<strong>每月射精21次以上的男性相比每月4-7次的男性，前列腺癌风险降低约20-30%</strong>。不过需要强调，这是观察性研究，不能直接得出因果结论。</p><p>关于"手淫导致阳痿"或"手淫导致早泄"的说法，目前<strong>缺乏科学证据支持</strong>。这些性功能障碍通常有更为复杂的病因，包括血管因素、神经因素、心理因素和内分泌因素等。</p><h2>女性生殖健康</h2><p>对于女性，手淫同样不存在已知的生殖健康危害。相反，手淫可能有助于<strong>了解自身身体</strong>，改善性体验，甚至在一定程度上缓解经期不适——性高潮时子宫的节律性收缩有助于缓解盆腔充血。</p><h2>关于精液质量</h2><p>频繁射精会<strong>暂时性地</strong>降低单次射精的精子数量，但对于有生育计划的男性，适度禁欲2-7天即可恢复最佳精子参数。长期来看，手淫频率对生育能力没有永久性影响。</p><h2>局部组织健康</h2><p>唯一值得注意的生理风险是<strong>机械性刺激</strong>。过于粗暴或使用不当方式可能导致局部擦伤或轻微水肿。使用适当的润滑剂、保持清洁卫生可以有效预防这些问题。</p><h2>结论</h2><p>从生殖健康角度看，适度的手淫行为是安全的。与其担忧手淫伤害身体，不如关注整体的生殖健康维护：定期体检、健康饮食、适度运动和安全性行为才是更重要的健康策略。</p>',
    author: '刘洋',
    date: '2026-07-12',
    readTime: '9 分钟',
    imageUrl: 'https://bodymindapp.github.io/api/search-image?query=Healthcare%20and%20reproductive%20health%20concept%20with%20medical%20symbols%20soft%20natural%20lighting%20clean%20professional%20aesthetic&width=800&height=600&seq=article-shengzhi&orientation=landscape',
    tags: ['生殖健康', '前列腺', '生育能力'],
  },
  {
    slug: 'shouyin-yu-jiaolv',
    title: '手淫与焦虑：打破"羞耻-焦虑"的恶性循环',
    category: 'xinli-yingxiang',
    excerpt: '许多人在手淫后体验到焦虑或内疚，这种情绪往往源于文化灌输而非行为本身。本文帮助读者识别并打破这一心理循环。',
    content: '<h2>焦虑的根源</h2><p>手淫后的焦虑感通常不是由行为本身引起的，而是由<strong>文化观念、家庭教育和社会禁忌</strong>塑造的。许多人在成长过程中被灌输了"手淫有害""手淫是可耻的"等负面信息，这些内化的观念在行为发生后自动激活，引发焦虑和负罪感。</p><h2>"手淫后焦虑综合征"</h2><p>一些人在手淫后体验到短暂的焦虑、空虚或低落，这种现象在互联网亚文化中被称为"贤者模式"。从生理角度看，这可能与<strong>高潮后催乳素水平的急剧上升和多巴胺的快速回落</strong>有关。这种生理性的情绪波动是暂时的、正常的。</p><h2>认知重构策略</h2><p>以下方法可帮助减少手淫相关的焦虑：</p><ul><li><strong>知识脱敏</strong>：学习科学的性健康知识，用事实替代恐惧</li><li><strong>自我对话</strong>：在手淫后主动告诉自己"这是一个正常、健康的生理行为"</li><li><strong>正念接纳</strong>：练习正念冥想，观察但不评判自己的身体感受和情绪反应</li><li><strong>文化反思</strong>：识别哪些负面观念来自外界灌输而非自己的真实体验</li></ul><h2>何时需要专业帮助</h2><p>如果手淫后的焦虑感<strong>持续数小时以上</strong>或<strong>严重影响日常生活</strong>，或伴随抑郁、失眠、社交退缩等症状，建议寻求心理咨询师或性治疗师的专业帮助。认知行为疗法（CBT）在处理此类问题上有较好的循证支持。</p><h2>健康的心态</h2><p>健康的性心理状态是：能够享受自己的身体，在行为后感到放松和满足，不带负罪感或羞耻感。这是每个人应有的权利，也是可以通过学习和练习达到的状态。</p>',
    author: '林悦',
    date: '2026-03-30',
    readTime: '8 分钟',
    imageUrl: 'https://bodymindapp.github.io/api/search-image?query=Peaceful%20meditation%20and%20mindfulness%20concept%20with%20soft%20warm%20lighting%20serene%20atmosphere%20minimalist%20design%20calm&width=800&height=600&seq=article-jiaolv&orientation=landscape',
    tags: ['焦虑', '认知重构', '心理健康'],
  },
  {
    slug: 'shouyin-yu-banlv-guanxi',
    title: '手淫与伴侣关系：是威胁还是补充',
    category: 'xinli-yingxiang',
    excerpt: '在有伴侣的情况下，手淫常常成为关系中的敏感话题。本文从关系心理学角度，分析手淫在亲密关系中的角色和影响。',
    content: '<h2>常见的误解</h2><p>许多伴侣将对方的手淫行为解读为"我不够有吸引力"或"我们的性生活不够好"。这种解读通常是<strong>不准确的</strong>。手淫和伴侣性行为是两种不同性质的体验，不是非此即彼的替代关系。</p><h2>手淫在关系中的积极角色</h2><p>在健康的关系中，手淫可以发挥多种积极作用：</p><ul><li><strong>自我了解</strong>：更好地了解自己的身体和性偏好，有助于与伴侣进行更有效的沟通</li><li><strong>压力管理</strong>：双方都有独立的压力释放方式，减轻对伴侣的不合理期待</li><li><strong>异地时期的补充</strong>：在伴侣因工作、旅行等原因暂时分开时，手淫是安全的性释放途径</li><li><strong>性功能维护</strong>：尤其对中老年人，手淫可帮助维持性器官的血液供应和功能</li></ul><h2>需要警惕的信号</h2><p>以下情况可能表明手淫正在对关系产生负面影响：</p><ul><li>系统性地选择手淫而回避与伴侣的性接触</li><li>对伴侣隐瞒行为并因此产生持续的愧疚感</li><li>手淫行为使一方感到被拒绝或被背叛</li></ul><h2>健康沟通策略</h2><p>如果这个话题在关系中引起紧张，建议：</p><ul><li>在非性情境下进行平静的沟通</li><li>用"我感受"句式替代指责性语言</li><li>共同学习科学的性健康知识</li><li>必要时寻求伴侣咨询的专业帮助</li></ul>',
    author: '林悦',
    date: '2026-05-18',
    readTime: '7 分钟',
    imageUrl: 'https://bodymindapp.github.io/api/search-image?query=Couple%20having%20warm%20conversation%20in%20cozy%20living%20room%20soft%20natural%20light%20intimate%20atmosphere%20clean&width=800&height=600&seq=article-banlv&orientation=landscape',
    tags: ['伴侣关系', '沟通', '亲密关系'],
  },
  {
    slug: 'shouyin-dao-di-you-mei-you-hai',
    title: '手淫到底有没有害？科学证据全面解读',
    category: 'changjian-wuqu',
    excerpt: '针对互联网上流传的各种"手淫危害论"，本文逐条对比科学证据，帮助读者分辨事实与谣言。',
    content: '<h2>谣言与科学的对比</h2><p>互联网上关于手淫危害的说法五花八门。以下将常见说法与科学证据进行逐一对比：</p><h3>说法一："手淫导致肾虚"</h3><p><strong>科学证据：不成立。</strong>"肾虚"是中医理论中的概念，现代医学中不存在与手淫直接相关的"肾功能损伤"证据。</p><h3>说法二："手淫导致脱发"</h3><p><strong>科学证据：不成立。</strong>男性型脱发主要由遗传因素和雄激素水平决定，与手淫无因果关系。</p><h3>说法三："手淫导致记忆力下降"</h3><p><strong>科学证据：不成立。</strong>没有研究证明手淫对认知功能有负面影响。</p><h3>说法四："手淫导致痤疮"</h3><p><strong>科学证据：不成立。</strong>痤疮主要与激素水平、皮脂分泌和细菌感染有关。</p><h3>说法五："手淫导致早泄"</h3><p><strong>科学证据：关系复杂。</strong>没有证据表明手淫直接"导致"早泄。一些性治疗师甚至建议使用手淫训练来帮助改善早泄问题。</p><h2>为什么这些谣言会广泛传播</h2><p>这些谣言之所以有市场，是因为它们利用了人们对未知的恐惧和传统文化中对性的禁忌。在缺乏系统性教育的环境中，人们倾向于用道德化的语言来解释和评判生理现象。</p>',
    author: '周明',
    date: '2026-04-05',
    readTime: '10 分钟',
    imageUrl: 'https://bodymindapp.github.io/api/search-image?query=Fact%20versus%20myth%20concept%20illustration%20with%20scientific%20evidence%20symbols%20clean%20modern%20design%20professional&width=800&height=600&seq=article-wuqu1&orientation=landscape',
    tags: ['谣言破除', '科学证据', '误区'],
  },
  {
    slug: 'shouyin-jielu-wenhua-pianjian',
    title: '手淫禁忌的文化根源：历史与宗教视角',
    category: 'changjian-wuqu',
    excerpt: '手淫禁忌并非普遍真理，而是特定文化和历史条件下的产物。本文追溯西方和东方文化中手淫禁忌的形成过程。',
    content: '<h2>西方文化中的手淫禁忌</h2><p>西方文化中对手淫的负面态度可以追溯到18世纪。1760年，瑞士医生蒂索出版了《论手淫产生的疾病》一书，<strong>首次将手淫系统性地描述为一种致病行为</strong>。尽管蒂索的理论缺乏科学依据，但他的著作在欧洲产生了深远影响。</p><p>19世纪，美国的格雷厄姆和凯洛格等人将手淫反对运动推向高峰。这些人的观点带有<strong>强烈的宗教和道德色彩</strong>，而非科学态度。</p><h2>中国传统文化中的态度</h2><p>中国传统医学和养生文化中对手淫的态度较为复杂。"一滴精十滴血"的说法在民间广为流传，这种观念源于中医"精血同源"的理论框架。另一方面，中国古代房中术文献中对性行为的讨论相对开放和务实。</p><h2>宗教传统的影响</h2><p>在亚伯拉罕诸教的传统教义中，手淫常被视为不当行为。不同教派的现代立场差异很大，许多自由派宗教团体已不再将手淫视为道德问题。</p><h2>现代观念的转变</h2><p>20世纪中叶以来，全球范围内对手淫的态度逐渐趋于理性和科学化。世界卫生组织等权威机构均将手淫视为<strong>正常的人类性行为</strong>。</p>',
    author: '周明',
    date: '2026-06-22',
    readTime: '11 分钟',
    imageUrl: 'https://bodymindapp.github.io/api/search-image?query=Historical%20books%20and%20cultural%20artifacts%20in%20warm%20library%20setting%20soft%20lighting%20scholarly%20atmosphere%20classic&width=800&height=600&seq=article-wenhua&orientation=landscape',
    tags: ['文化历史', '宗教', '禁忌根源'],
  },
  {
    slug: 'chengnianren-xing-jiankang-jiaoyu-zhinan',
    title: '成年人性健康教育指南：你需要知道的7件事',
    category: 'xing-jiaoyu',
    excerpt: '许多成年人在成长过程中缺乏系统的性教育。本文总结7条每位成年人都应了解的性健康基础知识。',
    content: '<h2>为什么成年人的性教育同样重要</h2><p>大多数人在学校接受的性教育集中在青春期生理变化和避孕知识上，内容往往<strong>不完整、不及时</strong>。成年后，人们面临更复杂的性健康议题，却缺乏可靠的信息来源。</p><h2>7条核心知识</h2><h3>1. 性健康是整体健康的一部分</h3><p>世界卫生组织将性健康定义为"与性有关的身体、情感、心理和社会健康状态"。</p><h3>2. 知情同意是性健康的基础</h3><p>所有性活动都应基于<strong>自由给予、可撤销、知情</strong>的同意。</p><h3>3. 了解你的身体</h3><p>无论男女，了解自身生殖解剖结构是性健康的基础。</p><h3>4. 定期进行性健康检查</h3><p>有性生活的成年人应定期进行性传播疾病筛查。</p><h3>5. 心理性健康同样重要</h3><p>性功能障碍等心理性问题可以通过专业帮助得到改善。</p><h3>6. 关系技能是可以学习的</h3><p>包括性沟通在内的关系技能并非天生的，而是可以学习和练习的。</p><h3>7. 安全措施多样化</h3><p>了解并选择适合自己的避孕和性病预防方法。</p>',
    author: '王芳',
    date: '2026-07-01',
    readTime: '9 分钟',
    imageUrl: 'https://bodymindapp.github.io/api/search-image?query=Modern%20health%20education%20concept%20with%20books%20and%20medical%20symbols%20clean%20bright%20aesthetic%20professional%20warm&width=800&height=600&seq=article-jiaoyu&orientation=landscape',
    tags: ['性教育', '健康知识', '成年人'],
  },
  {
    slug: 'shuzi-shidai-de-xing-jiankang',
    title: '数字时代的性健康：色情内容消费的影响',
    category: 'xing-jiaoyu',
    excerpt: '互联网时代，色情内容的易得性给性健康带来了新的挑战和议题。本文帮助读者理性评估和管理数字色情消费。',
    content: '<h2>一个不可回避的现实</h2><p>在智能手机普及的今天，色情内容的消费已成为全球性的普遍现象。数据显示，<strong>色情网站的访问量超过了许多主流社交媒体平台</strong>。正视这一现实而非回避，是进行有效性健康教育的前提。</p><h2>潜在的影响</h2><p>适度消费色情内容对大多数成年人可能没有显著负面影响，但以下方面值得关注：</p><ul><li><strong>性脚本塑造</strong>：色情内容中的性行为表现往往是夸张、非现实的</li><li><strong>身体形象焦虑</strong>：容易引发不切实际的比较和焦虑</li><li><strong>性唤起模式</strong>：过度依赖特定类型可能导致性唤起模式的窄化</li></ul><h2>健康消费策略</h2><ul><li><strong>保持批判性思维</strong>：记住色情内容是表演而非教育材料</li><li><strong>多样化性信息来源</strong>：用科学性教育材料补充或替代部分色情内容消费</li><li><strong>关注现实关系</strong>：确保数字消费不侵蚀现实中的亲密关系</li><li><strong>自我监控</strong>：如果发现消费影响了工作、社交或心理健康，考虑减少或寻求专业帮助</li></ul>',
    author: '陈静',
    date: '2026-08-02',
    readTime: '8 分钟',
    imageUrl: 'https://bodymindapp.github.io/api/search-image?query=Digital%20wellness%20concept%20with%20smartphone%20and%20health%20symbols%20modern%20minimalist%20design%20soft%20lighting&width=800&height=600&seq=article-shuzi&orientation=landscape',
    tags: ['数字时代', '色情内容', '媒体素养'],
  },
  {
    slug: 'jiankang-zixingwei-moshi',
    title: '建立健康的自慰行为模式：实用指南',
    category: 'xingwei-guanli',
    excerpt: '如果希望调整手淫习惯，本文提供实用的行为管理策略——基于认知行为疗法和正念技术的科学方法。',
    content: '<h2>行为管理的核心原则</h2><p>有效的自慰行为管理不是"彻底戒除"（对大多数人来说既不必要也不现实），而是<strong>建立有意识的选择权</strong>——你是手淫行为的主人，而非被冲动驱使。</p><h2>策略一：觉察与记录</h2><p>建议用一周时间记录手淫行为发生的情境：时间、地点、情绪状态、触发因素。这种<strong>自我监测</strong>是行为改变的第一步。</p><h2>策略二：刺激控制</h2><p>基于行为心理学原理，锁定行为链中的<strong>触发环节</strong>进行干预：</p><ul><li>如果在特定时间段自动发生，可以用其他活动（运动、阅读）替代</li><li>如果在特定环境触发，可以改变环境设置</li><li>如果由特定情绪触发，学习用其他方式应对这些情绪</li></ul><h2>策略三：推迟冲动</h2><p>当感到冲动时，尝试<strong>推迟15分钟</strong>再做决定。在这15分钟内进行其他活动。</p><h2>策略四：正念手淫</h2><p>有意识地进行手淫——专注于身体感受而非幻想内容。这种方法可以提高身体觉察能力，减少羞耻感，降低频率，提升满足感。</p><h2>策略五：丰富生活内容</h2><p>过高的手淫频率反映的可能是<strong>生活的单调和缺乏其他满足来源</strong>。增加运动、发展兴趣爱好、加强社交联系，这些都可能自然地调节手淫频率。</p>',
    author: '林悦',
    date: '2026-05-25',
    readTime: '10 分钟',
    imageUrl: 'https://bodymindapp.github.io/api/search-image?query=Healthy%20lifestyle%20habits%20concept%20with%20journal%20exercise%20and%20mindfulness%20warm%20natural%20lighting%20calm&width=800&height=600&seq=article-guanli&orientation=landscape',
    tags: ['行为管理', '正念', 'CBT'],
  },
  {
    slug: 'shouyin-chengyin-de-renzhi',
    title: '当手淫成为困扰：识别问题性使用模式',
    category: 'xingwei-guanli',
    excerpt: '虽然大多数人的手淫行为是健康的，但少数人可能发展出问题性使用模式。本文帮助读者识别需要关注的信号。',
    content: '<h2>区分"高频"与"问题性使用"</h2><p>频率高不等于有问题。问题性使用的核心特征是<strong>失控感和负面后果</strong>，而非频率本身。</p><h2>需要关注的信号</h2><ul><li><strong>时间失控</strong>：花费远超预期的时间</li><li><strong>功能损害</strong>：因手淫行为迟到、缺勤、失眠</li><li><strong>耐受性增加</strong>：需要越来越强烈的刺激</li><li><strong>戒断反应</strong>：试图减少时出现烦躁焦虑</li><li><strong>持续失控</strong>：多次尝试控制但反复失败</li><li><strong>关系损害</strong>：对亲密关系造成负面影响</li></ul><h2>可能的成因</h2><p>问题性手淫使用可能与其他因素相关：潜藏的焦虑或抑郁障碍、童年创伤经历、ADHD、社交孤立等。</p><h2>寻求帮助的途径</h2><ul><li><strong>心理咨询</strong>：CBT和ACT在处理此类问题上有循证支持</li><li><strong>性治疗师</strong>：专门针对性健康问题的专业治疗师</li><li><strong>支持团体</strong>：在线或线下的同伴互助</li><li><strong>自助资源</strong>：基于认知行为疗法的自助书籍和工作手册</li></ul><p>最重要的是，<strong>不要独自承受羞耻感</strong>。这是临床上常见的求助原因，专业人士会以非评判的态度提供帮助。</p>',
    author: '刘洋',
    date: '2026-08-08',
    readTime: '9 分钟',
    imageUrl: 'https://bodymindapp.github.io/api/search-image?query=Supportive%20counseling%20session%20with%20warm%20lighting%20professional%20setting%20compassionate%20atmosphere%20clean&width=800&height=600&seq=article-kunrao&orientation=landscape',
    tags: ['问题性使用', '求助', '心理健康'],
  },
];

export const faqItems = [
  {
    question: '手淫会导致肾虚吗？',
    answer: '不会。"肾虚"是中医理论概念，与现代医学中的肾脏功能不同。没有科学证据表明手淫会导致肾损伤或肾功能衰竭。适度的手淫对肾脏健康没有负面影响。',
  },
  {
    question: '手淫频率多少算"正常"？',
    answer: '不存在一个通用的"正常"标准。频率因人而异，从每月几次到每天几次都可以是健康的。关键在于行为是否让你感觉良好、是否影响日常生活功能、你是否有能力自主控制。',
  },
  {
    question: '手淫会影响生育能力吗？',
    answer: '适度的手淫不会影响长期生育能力。频繁射精会暂时降低单次精液中的精子浓度，但身体有很强的恢复能力。对于有生育计划的男性，适度禁欲2-7天即可恢复最佳精子参数。',
  },
  {
    question: '手淫会导致早泄吗？',
    answer: '没有证据表明手淫直接导致早泄。事实上，一些性治疗师会建议使用特定的手淫技术来帮助改善早泄问题。早泄的病因较为复杂，涉及生理和心理多个因素。',
  },
  {
    question: '女性手淫正常吗？',
    answer: '完全正常。手淫是所有性别中普遍存在的生理行为。女性手淫不仅是正常的，还有助于了解自身身体、改善性体验和整体性健康。',
  },
  {
    question: '有伴侣的人还需要手淫吗？',
    answer: '有伴侣的人手淫是完全正常的，不表示对伴侣不满意。手淫和伴侣间性行为是两种不同的体验，可以互补而非替代。关键在于双方对此持开放和理解的态度。',
  },
  {
    question: '如何判断自己的手淫行为是否有问题？',
    answer: '需要关注的信号包括：无法控制的强迫性冲动、行为严重影响工作或社交、导致身体损伤、伴随强烈的心理痛苦。如果这些情况持续存在，建议寻求专业心理咨询帮助。',
  },
  {
    question: '手淫后感到焦虑或内疚怎么办？',
    answer: '首先认识到这种感受往往来自文化灌输而非行为本身。建议学习科学的性健康知识，进行认知重构，练习正念接纳。如果焦虑持续影响生活，可以考虑寻求心理咨询师的帮助。',
  },
];